










import { Component, Vue, Watch } from 'vue-property-decorator';
import { Route } from 'vue-router';
import PageApiAgent from '../services/page-api-agent';
import BbParserService from '../services/bb-parser.service';

// @ts-ignore
@Component
// @ts-ignore
export default class Page extends Vue {
  // @ts-ignore
  public $route: Route;
  private content: string = '';
  private title: string = '';

  constructor(private pageApiAgent = PageApiAgent, private bbParserService = BbParserService) {
    super();
  }

  mounted() {
    this.idChanges();
  }

  get id () {
    return this.$route.params.id;
  }

  @Watch('id')
  // @ts-ignore
  private idChanges() {
    this.title = '';
    this.content = '';
    this.pageApiAgent.getById(this.id).then(result => {
      this.title = result.title;
      this.content = this.bbParserService.fromBb(result.content);
    });
  }

  private onClick(event: MouseEvent) {
    if (event !== null && event.srcElement.classList.contains('grouptitle')) {
      const id = event.srcElement.classList.item(1);
      if (event.srcElement.classList.contains('opened') && id !== null) {
        this.close(id);
      }
      else {
        this.open(id);
      }
    }
  }

  private open(id: string) {
    const text: HTMLElement = (<HTMLElement>this.$refs.text);
    if (text !== null) {
      text.querySelector('.group.' + id).classList.add('opened');
      text.querySelector('.grouptitle.' + id).classList.add('opened');
    }
  }

  private close(id: string) {
    const text: HTMLElement = (<HTMLElement>this.$refs.text);
    if (text !== null) {
      text.querySelector('.group.' + id).classList.remove('opened');
      text.querySelector('.grouptitle.' + id).classList.remove('opened');
    }
  }
}
